import {create} from "zustand"
import { setUser, isSessionValid, extendSession } from "../utils/auth"
import Cookies from "js-cookie"

const useAuthStore = create((set, get) => ({
    allUserData: null,
    loading: true, // Start with loading true

    user: () => ({
        user_id: get().allUserData?.user_id || null,
        username: get().allUserData?.username || null,
    }),
    
    setUser: (user) => set({allUserData: user}),
    setLoading: (loading) => set({ loading }),
    isLoggedIn: () => get().allUserData !== null,
    
    // Initialize auth state from stored tokens
    initializeAuth: async () => {
        try {
            const access_token = Cookies.get('access_token');
            const refresh_token = Cookies.get('refresh_token');
            
            console.log('Initializing auth - Access token exists:', !!access_token, 'Refresh token exists:', !!refresh_token);
            
            if (access_token && refresh_token) {
                // Check if session is still valid
                if (isSessionValid()) {
                    console.log('Session is valid, extending...');
                    // Extend session if needed
                    await extendSession();
                } else {
                    console.log('Session expired, trying to refresh...');
                    // Try to refresh the token
                    try {
                        await extendSession();
                    } catch (refreshError) {
                        console.log('Token refresh failed, clearing auth state');
                        // Clear invalid tokens
                        Cookies.remove('access_token');
                        Cookies.remove('refresh_token');
                        get().setUser(null);
                    }
                }
            } else {
                console.log('No tokens found, user not logged in');
                get().setUser(null);
            }
            
            get().setLoading(false);
        } catch (error) {
            console.error('Authentication initialization failed:', error);
            // Clear any invalid tokens
            Cookies.remove('access_token');
            Cookies.remove('refresh_token');
            get().setUser(null);
            get().setLoading(false);
        }
    },
    
    // Check and extend session if needed
    checkAndExtendSession: async () => {
        try {
            if (isSessionValid()) {
                await extendSession();
                return true;
            }
            return false;
        } catch (error) {
            console.error('Session check and extend failed:', error);
            return false;
        }
    }
}))

export { useAuthStore } 